(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-contact"]) return;
  try {
    
  const initialiseContactForms = (scope = document) => {
    scope.querySelectorAll('.mm-contact-form').forEach((form) => {
      if (form.dataset.mmContactReady) return;
      form.dataset.mmContactReady = 'true';
      const result = form.querySelector('[data-mm-contact-result]');
      if (result) result.focus();
      form.addEventListener('invalid', (event) => {
        const field = event.target;
        const error = document.getElementById(`${field.id}-error`);
        field.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = field.validationMessage;
      }, true);
      form.addEventListener('input', (event) => {
        const field = event.target;
        if (!field.matches('input,textarea') || !field.validity.valid) return;
        field.removeAttribute('aria-invalid');
        const error = document.getElementById(`${field.id}-error`);
        if (error) error.textContent = '';
      });
    });
  };
  initialiseContactForms();
  document.addEventListener('shopify:section:load', (event) => initialiseContactForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-gel-product"]) return;
  try {
    
(()=>{function init(){document.querySelectorAll('.mm-gel-main').forEach(root=>{if(root.dataset.gelReady)return;root.dataset.gelReady='true';root.querySelector('.mm-gel-rating').addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();document.querySelector('#gel-reviews')?.scrollIntoView({behavior:'smooth'});},true);const arrival=root.querySelector('.mm-gel-arrival');const relocate=()=>{const widget=root.querySelector('#visual_timer_wrapper');if(widget&&widget.parentElement!==arrival){arrival.querySelector('p').hidden=true;arrival.insertBefore(widget,arrival.querySelector('a'));}};const observer=new MutationObserver(relocate);observer.observe(root,{childList:true,subtree:true});relocate();const qty=root.querySelector('[name=quantity]');root.querySelectorAll('[data-gel-minus],[data-gel-plus]').forEach(b=>b.addEventListener('click',()=>{qty.value=Math.max(1,Math.min(9,Number(qty.value)+(b.hasAttribute('data-gel-plus')?1:-1)));qty.dispatchEvent(new Event('input',{bubbles:true}));}));const d=root.querySelector('.mm-gel-image-dialog');root.querySelector('[data-gel-zoom]').addEventListener('click',()=>{d.querySelector('img').src=root.querySelector('.pdp-image').currentSrc;d.showModal();});root.querySelector('[data-gel-close-image]').addEventListener('click',()=>d.close());});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();

(()=>{const boot=()=>{if(!document.querySelector('.mm-gel-main')||document.body.dataset.gelOverlayBound)return;document.body.dataset.gelOverlayBound='true';let queued=false;const update=()=>{queued=false;const banner=document.querySelector('#shopify-pc__banner'),prefs=document.querySelector('#shopify-pc__prefs');const visible=e=>!!e&&e.getClientRects().length>0&&getComputedStyle(e).visibility!=='hidden';const open=visible(banner)||visible(prefs);if(document.body.classList.contains('mm-gel-consent-open')!==open){document.body.classList.toggle('mm-gel-consent-open',open);document.dispatchEvent(new Event('mm:gel-overlays'));}if(open){const close=document.querySelector('button.klaviyo-close-form');if(visible(close))close.click();}};const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','class']});update();};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-gel-reviews"]) return;
  try {
    
(()=>{const setup=(scope=document)=>scope.querySelectorAll('.mm-gel-review-design').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const native=root.querySelector('.mm-gel-native-reviews'),cards=root.querySelector('.mm-gel-review-cards'),dialog=root.querySelector('dialog');root.querySelector('[data-gel-close-review]').addEventListener('click',()=>dialog.close());root.querySelector('[data-gel-all-reviews]').addEventListener('click',()=>{native.hidden=false;native.scrollIntoView({behavior:'smooth',block:'start'});});const update=()=>{const badge=document.querySelector('.mm-gel-rating .stamped-badge');if(badge){root.querySelector('[data-gel-rating]').textContent=badge.dataset.rating+' / 5';root.querySelector('[data-gel-review-count]').textContent=badge.querySelector('.stamped-badge-caption')?.textContent||badge.textContent;}if(cards.children.length)return;const reviews=[...native.querySelectorAll('.stamped-review[data-rating]')].filter(r=>r.querySelector('.stamped-review-content-body')?.textContent.trim()).slice(0,3);if(reviews.length<3)return;for(const review of reviews){const card=document.createElement('article');card.className='mm-gel-review-card';const rating=Math.max(0,Math.min(5,Number(review.dataset.rating))),score=document.createElement('div');score.className='mm-gel-review-score';score.textContent='★'.repeat(rating)+'☆'.repeat(5-rating)+'  '+rating+'/5';score.setAttribute('aria-label',rating+' / 5');const heading=document.createElement('h3');heading.textContent=review.querySelector('.stamped-review-header-title')?.textContent||'';const full=review.querySelector('.stamped-review-content-body').textContent.trim();let excerpt=full;if(full.length>155){const sentences=full.match(/[^.!?]+[.!?]+|[^.!?]+$/g)||[full];let text='';for(const sentence of sentences){if((text+sentence).length>155)break;text+=sentence;}if(text.trim())excerpt=text.trim();}const quote=document.createElement('blockquote');quote.textContent=excerpt;card.append(score,heading,quote);if(excerpt!==full){const more=document.createElement('button');more.type='button';more.className='mm-gel-read-review';more.textContent=root.dataset.readLabel;more.addEventListener('click',()=>{dialog.querySelector('h3').textContent=heading.textContent;dialog.querySelector('p').textContent=full;dialog.showModal();});card.append(more);}const author=document.createElement('div');author.className='mm-gel-review-author';const name=document.createElement('strong'),date=document.createElement('span');name.textContent=review.querySelector('.author')?.textContent||'';date.textContent=review.querySelector('.created')?.textContent||'';author.append(name,date);card.append(author);cards.append(card);}root.querySelector('.mm-gel-review-summary').hidden=false;root.querySelector('.mm-gel-review-source').hidden=false;native.hidden=true;};const observer=new MutationObserver(update);observer.observe(native,{childList:true,subtree:true});const rating=document.querySelector('.mm-gel-rating');if(rating)observer.observe(rating,{childList:true,subtree:true,attributes:true});update();root._cleanup=()=>observer.disconnect();});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(),{once:true});else setup();document.addEventListener('shopify:section:load',e=>setup(e.target));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.mm-gel-review-design').forEach(r=>r._cleanup?.()));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-header"]) return;
  try {
    
(() => {
  const boot = () => {
    const body = document.body;
    const root = body.dataset.mmRoot || '/';
    const review = body.dataset.mmReview === 'true';
    const previewTheme = review || body.dataset.mmPreview === 'true';
    const messages = JSON.parse(document.querySelector('[data-mm-messages]')?.textContent || '{}');
    const money = n => new Intl.NumberFormat('en-GB', {style:'currency',currency:body.dataset.mmCurrency || 'GBP'}).format(Number(n)/100);
    const url = (path, preview = false) => {
      const u = new URL(root + path, location.origin);
      if (preview && previewTheme) u.searchParams.set('preview_theme_id', body.dataset.mmTheme);
      return u;
    };
    const previewLinks = scope => {
      scope.querySelectorAll('a[href]').forEach(a => {
        const raw = a.getAttribute('href');
        if (!raw || raw.startsWith('#')) return;
        const u = new URL(raw, location.href);
        if(u.origin===location.origin&&/\/collections\/[^/]+\/?$/.test(u.pathname)&&!u.searchParams.has('sort_by'))u.searchParams.set('sort_by','best-selling');
        if (previewTheme && u.origin === location.origin && !u.pathname.startsWith('/tools/') && !u.pathname.startsWith('/account') && !u.pathname.includes('customer_authentication')) {
          u.searchParams.set('preview_theme_id', body.dataset.mmTheme);
        }
        a.href = u;
      });
    };
    previewLinks(document);
    document.addEventListener('mm:collection:updated',event=>{previewLinks(event.detail.section);if(window.StampedFn?.reloadUGC)window.StampedFn.reloadUGC();});
    document.querySelectorAll('.mainnav a,.menu-links a').forEach(link => {
      const target = new URL(link.href, location.href);
      const current = new URL(location.href);
      const shoppingRoute=/\/collections\/all\/?$/.test(target.pathname)&&/\/(collections|products)(\/|$)/.test(current.pathname);
      if (shoppingRoute || (target.pathname === current.pathname && target.searchParams.get('view') === current.searchParams.get('view'))) link.setAttribute('aria-current','page');
    });
    const toast = text => {
      const box = document.querySelector('[data-mm-toast]');
      if (!box) return;
      box.textContent = text; box.hidden = false;
      clearTimeout(box._timer); box._timer = setTimeout(() => box.hidden = true, 4500);
    };
    const post = async (path, payload) => {
      const response = await fetch(url(path), {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      let data;
      try { data = await response.json(); } catch { throw new Error(messages.network); }
      if (!response.ok) throw new Error(data.description || data.message || messages.network);
      return data;
    };
    const dialog = document.getElementById('mm-bag');
    let focusBeforeBag = null;
    let quickTrigger = null;
    let quickRequest = 0;
    let cartBusy = false;
    const quickDialog = document.getElementById('mm-quick');
    const topupLines = cart => cart.items.filter(item => item.handle === 'delivery-threshold-top-up');
    const basketSignature = cart => `${cart.total_price}:` + cart.items.map(item => `${item.key}:${item.quantity}:${item.final_line_price};`).join('');
    const validTopup = cart => {
      const lines = topupLines(cart);
      if (!lines.length) return true;
      const base = cart.total_price - lines.reduce((sum,item) => sum + item.final_line_price,0);
      const threshold = base < 3000 ? 3000 : 4000;
      const goods = cart.items.filter(item => item.handle !== 'delivery-threshold-top-up');
      return lines.length <= 2 && new Set(lines.map(line => line.variant_id)).size === lines.length && lines.every(line => line.quantity === 1 && Number(line.properties?._mm_delivery_threshold) === threshold) && base > 0 && threshold - base > 0 && cart.total_price === threshold && cart.total_discount === 0 && goods.length > 0 && goods.every(item => item.requires_shipping && !item.gift_card && !item.selling_plan_allocation && item.product_type !== 'Upcart - Shipping Protection');
    };
    const normalizeTopup = async cart => {
      if (validTopup(cart)) return cart;
      const updates = Object.fromEntries(topupLines(cart).map(item => [item.key,0]));
      return post('cart/update.js',{updates});
    };
    const refresh = async () => {
      const cart = await normalizeTopup(await normalizePackaging(await readCart()));
      document.dispatchEvent(new CustomEvent('mm:cart:updated', {detail: {cart}}));
      const drawerResponse = await fetch(url('cart?section_id=mm-cart-drawer',true),{cache:'no-store'});
      if (!drawerResponse.ok) throw new Error(messages.network);
      const html = await drawerResponse.text();
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const fragment = parsed.querySelector('.mm-drawer-content');
      if (!fragment) throw new Error(messages.network);
      document.querySelector('[data-mm-drawer-body]').innerHTML = fragment.innerHTML;
      document.querySelectorAll('[data-mm-count]').forEach(e => e.textContent = cart.item_count);
      const full = document.querySelector('[data-mm-full-cart]');
      if (full) {
        const r = await fetch(url('cart?section_id=mm-cart',true));
        if (!r.ok) throw new Error(messages.network);
        const doc = new DOMParser().parseFromString(await r.text(),'text/html');
        const section = doc.querySelector('[data-mm-full-cart]');
        if (section) full.innerHTML = section.innerHTML;
      }
      previewLinks(document);
    };
    document.documentElement.setAttribute('data-mm-topup-ready','');
    document.addEventListener('mm:cart:topup-request',async event => {
      const request = event.detail;
      if (cartBusy || quantityEdits.size) { request.reject(new Error(request.text.busy)); return; }
      cartBusy = true;
      const controls = [...document.querySelectorAll('.mm-cart-form button,.mm-cart-form input,.mm-cart-form select,[data-mm-checkout] button')].map(element => [element,element.disabled]);
      controls.forEach(([element]) => element.disabled = true);
      try {
        const cart = await readCart();
        if (basketSignature(cart) !== request.signature) { await refresh(); throw new Error(request.text.stale); }
        if (request.action === 'remove') {
          await post('cart/update.js',{updates:Object.fromEntries(topupLines(cart).map(item => [item.key,0]))});
        } else if (request.action === 'product') {
          const product = request.product;
          if (!product || !/^[a-z0-9-]+$/.test(product.handle) || cart.currency !== 'GBP') throw new Error(request.text.stale);
          const response = await fetch(url('products/' + product.handle + '.js'),{cache:'no-store'});
          if (!response.ok) throw new Error(request.text.error);
          const latestProduct = await response.json();
          const variant = latestProduct.variants.find(v => v.id === product.variant.id && v.price === product.variant.price && v.available && v.requires_shipping);
          if (!variant || latestProduct.requires_selling_plan || latestProduct.tags.includes('cart-add-on') || latestProduct.tags.includes('hidden-product')) throw new Error(request.text.stale);
          await post('cart/add.js',{items:[{id:variant.id,quantity:1}]});
        } else if (request.action === 'add') {
          const config = JSON.parse(document.querySelector('[data-mm-dispatch-config]').textContent);
          const amounts = [request.gap - request.gap % 100,request.gap % 100].filter(Boolean);
          const parts = amounts.map(amount => config.topupVariants.find(item => item.amount === amount && item.available));
          if (!parts.length || !parts.every(Boolean) || topupLines(cart).length || cart.currency !== 'GBP' || cart.total_discount !== 0 || !Number.isSafeInteger(request.gap) || request.gap < 1 || request.gap >= 3000 || request.threshold !== (cart.total_price < 3000 ? 3000 : 4000) || cart.total_price + request.gap !== request.threshold || !cart.items.length || !cart.items.every(item => item.requires_shipping && !item.gift_card && !item.selling_plan_allocation && item.product_type !== 'Upcart - Shipping Protection')) throw new Error(request.text.stale);
          await post('cart/add.js',{items:parts.map(variant => ({id:variant.id,quantity:1,properties:{_mm_delivery_threshold:String(request.threshold)}}))});
        } else throw new Error(request.text.error);
        await refresh();
        request.resolve();
      } catch(error) { request.reject(new Error(error.message || request.text.error)); }
      finally {
        cartBusy = false;
        controls.forEach(([element,disabled]) => { if (element.isConnected) element.disabled = disabled; });
      }
    });
    const openBag = async () => { location.assign(url('cart',true)); };
    dialog?.addEventListener('close', () => {body.style.overflow='';focusBeforeBag?.focus();});
    quickDialog?.addEventListener('close', () => {quickRequest++;body.style.overflow=dialog.open?'hidden':'';quickTrigger?.focus();});
    const packagingVariant=58407598326144;
    const packagingAttribute='Insulated packaging';
    const packagingNote='Insulated packaging: Yes (complimentary liner + ice pack).';
    const readCart=async()=>{const response=await fetch(url('cart.js'),{cache:'no-store'});if(!response.ok)throw new Error(messages.network);return response.json();};
    const cartHasGel=async()=>{
      const response=await fetch(url('cart?section_id=mm-packaging-state',true),{cache:'no-store'});
      if(!response.ok)throw new Error(messages.network);
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const state=parsed.querySelector('[data-mm-packaging-state]');
      if(!state)throw new Error(messages.network);
      return state.dataset.mmPackagingEligible==='true';
    };
    const packagingNoteValue=(note,selected)=>{
      const remaining=(note||'').split('\n').filter(line=>line.replace(/\r$/,'')!==packagingNote).join('\n');
      return selected ? remaining+(remaining&&!remaining.endsWith('\n')?'\n':'')+packagingNote : remaining;
    };
    const savePackaging=async(cart,selected)=>{
      const value=selected?'Yes':'';
      const note=packagingNoteValue(cart.note,selected);
      if((cart.attributes?.[packagingAttribute]||'')===value&&(cart.note||'')===note)return cart;
      return post('cart/update.js',{attributes:{[packagingAttribute]:value},note});
    };
    const normalizePackaging=async(cart,requested)=>{
      const legacy=cart.items.filter(item=>item.variant_id===packagingVariant);
      const selected=requested===undefined ? cart.attributes?.[packagingAttribute]==='Yes'||legacy.length>0 : requested;
      const eligible=selected ? await cartHasGel() : false;
      if(requested===true&&!eligible)throw new Error(messages.packaging_requires_gel);
      cart=await savePackaging(cart,Boolean(selected&&eligible));
      let oldLine=cart.items.find(item=>item.variant_id===packagingVariant);
      while(oldLine){
        cart=await post('cart/change.js',{id:oldLine.key,quantity:0});
        oldLine=cart.items.find(item=>item.variant_id===packagingVariant);
      }
      return cart;
    };
    const removeIneligiblePackaging=cart=>normalizePackaging(cart);
    const updatePackaging=async checkbox=>{
      if(cartBusy||quantityEdits.size){checkbox.checked=!checkbox.checked;toast(messages.cart_updating);return;}
      cartBusy=true;const selected=checkbox.checked;const status=checkbox.closest('.mm-packaging').querySelector('[data-mm-packaging-status]');
      document.querySelectorAll('[data-mm-packaging]').forEach(input=>input.disabled=true);status.textContent=messages.cart_updating;
      try{
        await normalizePackaging(await readCart(),selected);
        await refresh();toast(selected?messages.packaging_added:messages.packaging_removed);
      }catch(error){
        try{await refresh();}catch{checkbox.checked=!selected;}
        status.textContent=error.message;toast(error.message);
      }finally{cartBusy=false;document.querySelectorAll('[data-mm-packaging]').forEach(input=>input.disabled=false);}
    };
    const updateDiscount=async(form,clear=false)=>{
      if(cartBusy)return;
      const input=form.querySelector('[data-mm-discount-input]');const code=clear?'':input.value.trim();
      if(!clear&&!code){input.focus();return;}
      const inDrawer=Boolean(form.closest('#mm-bag'));const status=form.querySelector('[data-mm-discount-status]');
      cartBusy=true;form.setAttribute('aria-busy','true');form.querySelectorAll('button,input').forEach(e=>e.disabled=true);status.textContent=messages.discount_checking;
      try{
        const cart=await post('cart/update.js',{discount:code});await refresh();
        const rejected=Array.isArray(cart.discount_codes)&&cart.discount_codes.some(item=>item.applicable===false);
        const message=clear?messages.discount_removed:rejected?messages.discount_rejected:messages.discount_checked;
        const scope=inDrawer?dialog:document.querySelector('[data-mm-full-cart]');const next=scope?.querySelector('[data-mm-discount-form]');
        if(next){const disclosure=next.closest('details');if(disclosure)disclosure.open=true;next.querySelector('[data-mm-discount-status]').textContent=message;next.querySelector('[data-mm-discount-input]').value=code;next.querySelector('[data-mm-discount-input]').focus();}
        toast(message);
      }catch(error){status.textContent=error.message;toast(error.message);}
      finally{cartBusy=false;form.removeAttribute('aria-busy');form.querySelectorAll('button,input').forEach(e=>e.disabled=false);}
    };
    const quantityEdits=new Map();
    const cancelQuantityEdit=key=>{const edit=quantityEdits.get(key);if(edit)clearTimeout(edit.timer);quantityEdits.delete(key);};
    const queueQuantityEdit=(input,immediate=false)=>{
      if(!input||input.disabled)return;
      const key=input.dataset.mmLineKey;
      cancelQuantityEdit(key);
      const edit={input,value:input.value,timer:null};quantityEdits.set(key,edit);
      const commit=()=>{
        if(quantityEdits.get(key)!==edit)return;
        if(cartBusy){edit.timer=setTimeout(commit,80);return;}
        const current=edit.input.isConnected?edit.input:Array.from(document.querySelectorAll('[data-mm-line-key]')).find(item=>item.dataset.mmLineKey===key);
        quantityEdits.delete(key);
        if(!current)return;
        current.value=edit.value;
        const value=edit.value.trim();
        updateCartLine(current,/^\d+$/.test(value)?Number(value):NaN,current);
      };
      if(immediate)commit();else edit.timer=setTimeout(commit,350);
    };
    const updateCartLine=async(input,quantity,trigger)=>{
      if(cartBusy||!input||!input.isConnected)return;
      cancelQuantityEdit(input.dataset.mmLineKey);
      const form=input.closest('.mm-cart-form');const status=form.querySelector('[data-mm-cart-status]');
      if(input.max && quantity>Number(input.max)){status.textContent=messages.packaging_limit;input.setAttribute('aria-invalid','true');return;}
      if(!Number.isSafeInteger(quantity)||quantity<0){status.textContent=messages.quantity_invalid;input.setAttribute('aria-invalid','true');return;}
      input.removeAttribute('aria-invalid');
      if(quantity===Number(input.dataset.mmOriginalQuantity)){status.textContent='';return;}
      const restoreFocus=document.activeElement===input||document.activeElement===trigger;
      const key=input.dataset.mmLineKey;const step=trigger?.dataset.mmQuantityStep;const inDrawer=Boolean(input.closest('#mm-bag'));
      cartBusy=true;
      document.querySelectorAll('.mm-cart-form').forEach(f=>{f.setAttribute('aria-busy','true');f.querySelectorAll('button,input').forEach(e=>e.disabled=true);f.querySelector('[data-mm-cart-status]').textContent=messages.cart_updating;});
      try{
        const changed=await post('cart/change.js',{id:key,quantity});await removeIneligiblePackaging(changed);await refresh();toast(quantity===0?messages.removed:messages.updated);
        const scope=inDrawer?dialog:document.querySelector('[data-mm-full-cart]');
        const replacement=Array.from(scope?.querySelectorAll('[data-mm-line-key]')||[]).find(e=>e.dataset.mmLineKey===key);
        if(replacement&&restoreFocus){const focus=step?replacement.closest('[data-mm-cart-line]').querySelector('[data-mm-quantity-step="'+step+'"]'):replacement;focus?.focus();}
        else if(!replacement&&restoreFocus)scope?.querySelector('button,a')?.focus();
      }catch(error){input.setAttribute('aria-invalid','true');status.textContent=error.message||messages.cart_error;toast(error.message||messages.cart_error);if(restoreFocus)trigger?.focus();}
      finally{cartBusy=false;document.querySelectorAll('.mm-cart-form').forEach(f=>{f.removeAttribute('aria-busy');f.querySelectorAll('button,input').forEach(e=>e.disabled=false);f.querySelectorAll('[data-mm-line-key][max]').forEach(input=>{input.closest('[data-mm-cart-line]').querySelector('[data-mm-quantity-step="1"]').disabled=Number(input.value)>=Number(input.max);});});}
    };
    const addCartRecommendation = async (form) => {
      const status = form.querySelector('[data-mm-offer-status]');
      if (cartBusy || quantityEdits.size) { status.textContent = messages.cart_updating; return; }
      const field = form.querySelector('[name="id"]');
      const selected = field.selectedOptions ? field.selectedOptions[0] : field;
      const variantId = Number(field.value);
      const expectedPrice = Number(selected.dataset.mmOfferPrice);
      const handle = form.dataset.mmOfferHandle;
      if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isSafeInteger(expectedPrice) || expectedPrice < 0 || !/^[a-z0-9-]+$/.test(handle)) { status.textContent = messages.plan_stale; return; }
      const controls = [...document.querySelectorAll('[data-mm-cart-offer] button,[data-mm-cart-offer] select')].map(element => [element,element.disabled]);
      cartBusy = true; form.setAttribute('aria-busy','true');
      controls.forEach(([element]) => element.disabled = true);
      status.textContent = messages.cart_updating;
      let added = false;
      try {
        const response = await fetch(url('products/' + handle + '.js'),{cache:'no-store'});
        if (!response.ok) throw new Error(messages.network);
        const product = await response.json();
        const variant = product.variants.find(item => item.id === variantId && item.available && item.price === expectedPrice);
        if (!variant || product.requires_selling_plan || product.tags.includes('cart-add-on') || product.tags.includes('hidden-product')) { await refresh(); throw new Error(messages.plan_stale); }
        await post('cart/add.js',{items:[{id:variantId,quantity:1}]});
        added = true;
        await refresh();
        const nextStatus = document.querySelector('[data-mm-full-cart] [data-mm-cart-status]');
        if (nextStatus) { nextStatus.textContent = messages.added; nextStatus.tabIndex = -1; nextStatus.focus(); }
        toast(messages.added);
      } catch (error) {
        const message = added ? messages.plan_uncertain : (error.message || messages.cart_error);
        const target = status.isConnected ? status : document.querySelector('[data-mm-full-cart] [data-mm-cart-status]');
        if (target) target.textContent = message;
        toast(message);
      } finally {
        cartBusy = false; form.removeAttribute('aria-busy');
        controls.forEach(([element,disabled]) => { if (element.isConnected) element.disabled = disabled; });
      }
    };
    const changeCartPlan = async (button) => {
      const panel = button.closest('[data-mm-cart-subscription]');
      const status = panel.querySelector('[data-mm-plan-status]');
      if (cartBusy || quantityEdits.size) { status.textContent = messages.cart_updating; return; }
      const select = panel.querySelector('[data-mm-cart-plan]');
      const plan = button.dataset.mmChangePlan === 'once' ? null : Number(select?.value);
      if (plan !== null && (!Number.isSafeInteger(plan) || plan <= 0)) {
        status.textContent = messages.plan_select_error; select?.focus(); return;
      }
      const inDrawer = Boolean(button.closest('#mm-bag'));
      const controls = [...document.querySelectorAll('.mm-cart-form button,.mm-cart-form input,.mm-cart-form select')].map(element => [element,element.disabled]);
      cartBusy = true; panel.setAttribute('aria-busy','true');
      controls.forEach(([element]) => element.disabled = true);
      status.textContent = messages.cart_updating;
      let changed = false;
      let swapAttempted = false;
      try {
        const cart = await readCart();
        const index = cart.items.findIndex(item => item.key === button.dataset.mmChangeKey);
        const item = cart.items[index];
        if (!item || item.quantity !== Number(button.dataset.mmExpectedQuantity) || String(item.selling_plan_allocation?.selling_plan?.id || '') !== button.dataset.mmOriginalPlan) {
          await refresh(); throw new Error(messages.plan_stale);
        }
        const targetVariant = Number(button.dataset.mmSwitchVariant || 0);
        if (targetVariant) {
          const duoPairs = new Map([[60164481089920,60150476177792],[60164481122688,60150476210560],[60150476177792,60164481089920],[60150476210560,60164481122688]]);
          if (duoPairs.get(item.variant_id) !== targetVariant || (plan !== null && plan !== 739184214400)) throw new Error(messages.plan_stale);
          const properties = item.properties || {};
          const propertySignature = value => JSON.stringify(Object.entries(value || {}).sort(([a],[b]) => a.localeCompare(b)));
          const sameProperties = candidate => propertySignature(candidate.properties) === propertySignature(properties);
          const sourcePlan = String(item.selling_plan_allocation?.selling_plan?.id || '');
          const targetQuantity = basket => basket.items.filter(candidate => candidate.variant_id === targetVariant && String(candidate.selling_plan_allocation?.selling_plan?.id || '') === String(plan || '') && sameProperties(candidate)).reduce((sum,candidate) => sum + candidate.quantity,0);
          const previousQuantity = targetQuantity(cart);
          const replacement = {id:targetVariant,quantity:item.quantity,properties};
          if (plan !== null) replacement.selling_plan = plan;
          swapAttempted = true;
          await post('cart/add.js',{items:[replacement]});
          const updated = await readCart();
          const sources = updated.items.filter(candidate => candidate.variant_id === item.variant_id && String(candidate.selling_plan_allocation?.selling_plan?.id || '') === sourcePlan && sameProperties(candidate));
          if (sources.length !== 1 || sources[0].quantity !== item.quantity || targetQuantity(updated) !== previousQuantity + item.quantity) throw new Error(messages.plan_stale);
          await post('cart/change.js',{id:sources[0].key,quantity:0});
        } else {
          await post('cart/change.js',{line:index+1,quantity:item.quantity,selling_plan:plan});
        }
        changed = true;
        await refresh();
        const scope = inDrawer ? dialog : document.querySelector('[data-mm-full-cart]');
        const nextStatus = scope?.querySelector('[data-mm-cart-status]');
        if (nextStatus) { nextStatus.textContent = messages.plan_success; nextStatus.tabIndex = -1; nextStatus.focus(); }
        toast(messages.plan_success);
      } catch (error) {
        const message = swapAttempted ? messages.plan_swap_uncertain : (changed ? messages.plan_uncertain : (error.message || messages.cart_error));
        if (swapAttempted) { try { await refresh(); } catch {} }
        const scope = inDrawer ? dialog : document.querySelector('[data-mm-full-cart]');
        const target = swapAttempted ? scope?.querySelector('[data-mm-cart-status]') : (status.isConnected ? status : scope?.querySelector('[data-mm-cart-status]'));
        if (target) target.textContent = message;
        toast(message);
      } finally {
        cartBusy = false; panel.removeAttribute('aria-busy');
        controls.forEach(([element,disabled]) => { if(element.isConnected) element.disabled = disabled; });
      }
    };
    document.addEventListener('change',event=>{if(event.target.matches('[data-mm-cart-plan]')){const select=event.target;select.closest('[data-mm-cart-subscription]').querySelector('[data-mm-plan-preview]').textContent=select.value?select.selectedOptions[0].textContent:'';}});
    document.addEventListener('input',event=>{if(event.target.matches('[data-mm-line-key]'))queueQuantityEdit(event.target);});
    document.addEventListener('change',event=>{if(event.target.matches('[data-mm-line-key]'))queueQuantityEdit(event.target);if(event.target.matches('[data-mm-packaging]'))updatePackaging(event.target);});
    document.addEventListener('focusout',event=>{
      if(!event.target.matches('[data-mm-line-key]'))return;
      const action=event.relatedTarget?.closest('[data-mm-quantity-step],[data-mm-remove]');
      if(action&&action.closest('[data-mm-cart-line]')===event.target.closest('[data-mm-cart-line]'))return;
      queueQuantityEdit(event.target,true);
    });
    document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('[data-mm-line-key]')){event.preventDefault();queueQuantityEdit(event.target,true);}});
    document.addEventListener('click', async event => {
      const discountClear=event.target.closest('[data-mm-discount-clear]');if(discountClear)await updateDiscount(discountClear.closest('form'),true);
      const open = event.target.closest('[data-mm-open-bag]');
      if (open) {
        event.preventDefault();
        try {await openBag(open);} catch (error) {toast(error.message);location.href=url('cart',true);}
      }
      if (event.target.closest('[data-mm-close]')) dialog.close();
      if(event.target.closest('[data-mm-close-quick]')) quickDialog.close();
      const quick=event.target.closest('[data-mm-quick]');
      if(quick){
        event.preventDefault();quickTrigger=quick;const request=++quickRequest;
        const target=quickDialog.querySelector('[data-mm-quick-body]');target.textContent=messages.quick_loading;
        document.getElementById('mm-quick-title').textContent=quick.closest('.product-card')?.querySelector('h3')?.textContent||quick.textContent;
        quickDialog.showModal();body.style.overflow='hidden';
        try{
          const productUrl=new URL(quick.href);productUrl.searchParams.set('section_id','mm-product');
          const response=await fetch(productUrl);if(!response.ok)throw new Error(messages.quick_error);
          const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
          const source=parsed.querySelector('[data-mm-product]');
          if(!source?.querySelector('.mm-product-form'))throw new Error(messages.quick_error);
          if(request!==quickRequest||!quickDialog.open)return;
          const product=document.createElement('div');product.setAttribute('data-mm-product','');
          const photo=source.querySelector('.pdp-image');if(photo)product.append(photo.cloneNode(true));
          product.append(source.querySelector('[data-mm-price]').cloneNode(true),source.querySelector('.mm-product-form').cloneNode(true),source.querySelector('[data-mm-product-data]').cloneNode(true));
          product.querySelectorAll('[id]').forEach(e=>{const old=e.id;const next='quick-'+old;product.querySelectorAll('[for]').forEach(label=>{if(label.htmlFor===old)label.htmlFor=next;});e.id=next;});
          target.replaceChildren(product);
          const full=document.createElement('a');full.className='link mm-quick-details';full.href=quick.href;full.textContent=messages.full_details;target.append(full);
          previewLinks(target);initialiseProduct(product,false,quick.href);
        }catch(error){if(request!==quickRequest)return;target.textContent=messages.quick_error;const full=document.createElement('a');full.className='btn outline full';full.href=quick.href;full.textContent=messages.full_details;target.append(full);}
      }
      const planChange = event.target.closest('[data-mm-change-plan]');
      if (planChange) { event.preventDefault(); await changeCartPlan(planChange); return; }
      const remove = event.target.closest('[data-mm-remove]');
      if (remove) await updateCartLine(remove.closest('[data-mm-cart-line]').querySelector('[data-mm-line-key]'),0,remove);
      const step=event.target.closest('[data-mm-quantity-step]');
      if(step){const input=step.closest('[data-mm-cart-line]').querySelector('[data-mm-line-key]');await updateCartLine(input,Math.max(0,Number(input.value)+Number(step.dataset.mmQuantityStep)),step);}
      const image = event.target.closest('[data-mm-image]');
      if (image) {
        const target=image.closest('[data-mm-product]').querySelector('.pdp-image');
        target.src=image.dataset.mmImage;target.removeAttribute('srcset');
      }
    });
    let checkoutPending=false;
    document.addEventListener('submit', async event => {
      const form=event.target;
      if(form.matches('[data-mm-checkout]')){
        if(form.dataset.mmReady==='true'){delete form.dataset.mmReady;return;}
        event.preventDefault();
        if(checkoutPending)return;
        checkoutPending=true;
        const inDrawer=Boolean(form.closest('#mm-bag'));
        let acquired=false;
        try{
          if(cartBusy||quantityEdits.size){
            toast(messages.cart_updating);
            const deadline=Date.now()+10000;
            while(cartBusy||quantityEdits.size){
              if(Date.now()>=deadline)throw new Error(messages.cart_updating);
              await new Promise(resolve=>setTimeout(resolve,50));
            }
          }
          cartBusy=true;acquired=true;
          const cart=await normalizeTopup(await normalizePackaging(await readCart()));
          if(!cart.item_count){await refresh();return;}
          const currentForm=form.isConnected?form:(inDrawer?dialog:document.querySelector('[data-mm-full-cart]'))?.querySelector('[data-mm-checkout]');
          if(!currentForm)throw new Error(messages.cart_error);
          currentForm.dataset.mmReady='true';
          currentForm.requestSubmit(currentForm.querySelector('[name="checkout"]'));
        }catch(error){toast(error.message);}
        finally{if(acquired)cartBusy=false;checkoutPending=false;}
        return;
      }
      if(form.matches('[data-mm-cart-offer]')){event.preventDefault();await addCartRecommendation(form);return;}
      if(form.matches('[data-mm-discount-form]')){event.preventDefault();await updateDiscount(form);}
      if(form.matches('.mm-cart-form')) {
        event.preventDefault();
        form.querySelectorAll('[data-mm-line-key]').forEach(input=>queueQuantityEdit(input,true));
      }
      if(form.matches('[data-mm-demo-form]')) {
        event.preventDefault();let status=form.querySelector('output');
        if(!status){status=document.createElement('output');status.className='mm-status';form.append(status);}
        status.textContent=messages.demo;
      }
      if(form.closest('.delivery-check')) {
        event.preventDefault();const value=form.querySelector('input').value.trim().toUpperCase();
        let result=form.parentElement.querySelector('output');
        if(!result){result=document.createElement('output');result.className='notice';form.after(result);}
        result.textContent=!/^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/.test(value)?messages.postcode:/^(GY|JE|IM)/.test(value)?messages.islands:value.startsWith('BT')?messages.ni:messages.uk;
      }
    });
    const initialiseProduct=(product,updateUrl=true,sourceUrl=location.href)=> {
      const data=JSON.parse(product.querySelector('[data-mm-product-data]').textContent);
      const form=product.querySelector('.mm-product-form');
      const variantSelect=form.querySelector('[data-mm-variant]');
      const planSelect=form.querySelector('[data-mm-plan]');
      product.querySelector('.mm-variant-choices').hidden=data.variants.length<2;
      variantSelect.hidden=true;
      form.querySelectorAll('[data-mm-variant-choice]').forEach(radio=>radio.addEventListener('change',()=>{variantSelect.value=radio.value;variantSelect.dispatchEvent(new Event('change',{bubbles:true}));}));

      const once=form.querySelector('[value=once]');
      const subscribe=form.querySelector('[value=subscribe]');
      const quantity=form.querySelector('[name=quantity]');
      const add=form.querySelector('[data-mm-add]');
      const buyNow=form.querySelector('[data-mm-buy-now]');
      if(updateUrl && 'IntersectionObserver' in window){
        const purchaseRow=form.querySelector('.buyrow');
        if(purchaseRow){
          const purchaseObserver=new IntersectionObserver(entries=>{
            document.body.classList.toggle('mm-purchase-visible',entries.some(entry=>entry.isIntersecting));
          },{rootMargin:'80px 0px'});
          purchaseObserver.observe(purchaseRow);
        }
      }
      const status=form.querySelector('[data-mm-product-status]');
      const purchaseAvailableFor=(variant,isSub)=>{
        if(!isSub)return !variant.requiresPlan&&variant.available;
        if(!variant.plans.length)return false;
        if(Array.isArray(variant.subscriptionItems))return variant.subscriptionItems.length>0&&variant.subscriptionItems.every(component=>component.available&&!component.requiresComponents);
        if(variant.subscriptionTarget)return variant.subscriptionTarget.available;
        return variant.available;
      };
      const entry=new URL(sourceUrl,location.href);
      const requestedVariant=data.variants.find(v=>String(v.id)===entry.searchParams.get('variant'));
      const enteredOnce=entry.searchParams.get('purchase')==='once';
      const enteredSubscription=!enteredOnce&&(entry.searchParams.get('purchase')==='subscription'||entry.searchParams.has('selling_plan'));
      if(requestedVariant)variantSelect.value=String(requestedVariant.id);
      else if(enteredSubscription){const eligible=data.variants.find(v=>purchaseAvailableFor(v,true));if(eligible)variantSelect.value=String(eligible.id);}
      if(enteredOnce){once.checked=true;subscribe.checked=false;}
      else if(enteredSubscription){subscribe.checked=true;once.checked=false;}
      else {once.checked=true;subscribe.checked=false;}
      if(entry.searchParams.has('quantity')){const requestedQuantity=Number(entry.searchParams.get('quantity'));if(Number.isInteger(requestedQuantity)&&requestedQuantity>=1&&requestedQuantity<=9)quantity.value=String(requestedQuantity);}
      let selectedVariant=null;
      const sync=()=> {
        const variant=data.variants.find(v=>String(v.id)===variantSelect.value);if(!variant)return;
        const previousPlan=selectedVariant===null?entry.searchParams.get('selling_plan')||planSelect.value:planSelect.value;
        if(selectedVariant!==variant.id) {
          planSelect.replaceChildren();
          variant.plans.forEach(p=>{const option=document.createElement('option');option.value=p.id;option.textContent=p.name+' · '+money(p.price);planSelect.append(option);});
          if(variant.plans.some(p=>String(p.id)===previousPlan))planSelect.value=previousPlan;
          if(variant.image){const image=product.querySelector('.pdp-image');if(image){image.src=variant.image;image.removeAttribute('srcset');}}
          selectedVariant=variant.id;

        }
        form.querySelectorAll('[data-mm-variant-choice]').forEach(radio=>radio.checked=String(variant.id)===radio.value);
        form.querySelector('[data-mm-sub-label]').hidden=!variant.plans.length&&!subscribe.checked;
        form.querySelector('[data-mm-once-label]').hidden=variant.requiresPlan;
        once.disabled=variant.requiresPlan;
        if(variant.requiresPlan)subscribe.checked=true;

        const isSub=subscribe.checked;
        Array.from(variantSelect.options).forEach(option=>{
          const choice=data.variants.find(item=>String(item.id)===option.value);
          if(!choice)return;
          option.disabled=!purchaseAvailableFor(choice,isSub);
          option.textContent=choice.title+(option.disabled?' — '+messages.unavailable:'');
        });
        form.querySelectorAll('[data-mm-variant-choice]').forEach(radio=>{
          const choice=data.variants.find(item=>String(item.id)===radio.value);
          radio.disabled=!choice||!purchaseAvailableFor(choice,isSub);
          const unavailable=radio.closest('label').querySelector('[data-mm-variant-unavailable]');
          if(unavailable)unavailable.hidden=!radio.disabled;
          const tilePrice=radio.closest('label').querySelector('[data-mm-variant-price]');
          if(tilePrice&&choice){const allocation=choice.plans.find(p=>String(p.id)===planSelect.value)||choice.plans[0];tilePrice.textContent=money(isSub&&allocation?allocation.price:choice.price);}
        });
        const subscriptionNote=form.querySelector('[data-mm-subscription-note]');
        if(subscriptionNote)subscriptionNote.hidden=!isSub||!variant.plans.length;
        form.querySelector('[data-mm-plan-panel]').hidden=!isSub||(variant.plans.length===1&&Boolean(subscriptionNote));
        planSelect.disabled=!isSub;planSelect.required=isSub;
        const plan=variant.plans.find(p=>String(p.id)===planSelect.value);
        const price=isSub&&plan?plan.price:variant.price;
        product.querySelector('[data-mm-price]').textContent=money(price);
        const savingAllocation=plan||variant.plans[0];
        const saving=savingAllocation&&variant.price>0?Math.max(0,Math.round((variant.price-savingAllocation.price)/variant.price*1000)/10):0;
        const savingText=form.querySelector('[data-mm-sub-saving]');
        const savingHeading=form.querySelector('[data-mm-sub-heading]');
        if(savingText){savingText.textContent=savingText.dataset.savingTemplate.replace('__AMOUNT__',saving+'%');savingText.hidden=saving<=0;}
        if(savingHeading)savingHeading.textContent=savingHeading.dataset.labelSubscribe;
        const subscriptionPrice=form.querySelector('[data-mm-sub-price]');
        if(subscriptionPrice)subscriptionPrice.textContent=savingAllocation?money(savingAllocation.price):'';
        form.querySelector('[data-mm-once-price]').textContent=money(variant.price);
        const qty=Math.max(1,Math.min(9,Number(quantity.value)||1));
        const purchaseAvailable=purchaseAvailableFor(variant,isSub);
        add.disabled=cartBusy||!purchaseAvailable||(isSub&&!plan);
        if(buyNow){buyNow.disabled=add.disabled;buyNow.textContent=purchaseAvailable?(isSub?messages.subscribe_now:messages.buy_now):messages.unavailable;}
        form.querySelectorAll('[data-mm-product-step]').forEach(button=>{button.disabled=cartBusy||(Number(button.dataset.mmProductStep)<0?qty<=Number(quantity.min):qty>=Number(quantity.max));});
        if(isSub&&!plan){status.textContent=messages.no_plan_variant;status.dataset.mmPlanError='true';}else if(status.dataset.mmPlanError){status.textContent='';delete status.dataset.mmPlanError;}
        add.textContent=purchaseAvailable?messages.add:messages.unavailable;
        form.querySelector('[data-mm-recurring]').textContent=isSub&&plan?qty+(variant.title?' × '+variant.title:'')+' · '+money(price*qty)+' · '+plan.name+'. '+messages.renew:'';
        const selectionUrl=new URL(updateUrl?location.href:sourceUrl,location.href);
        selectionUrl.searchParams.set('variant',variant.id);selectionUrl.searchParams.set('quantity',qty);
        selectionUrl.searchParams.set('purchase',isSub?'subscription':'once');
        if(isSub&&plan)selectionUrl.searchParams.set('selling_plan',plan.id);else selectionUrl.searchParams.delete('selling_plan');
        if(updateUrl){
          history.replaceState({},'',selectionUrl);
          const favicon=document.querySelector('link[data-mm-product-favicon="true"]');
          if(favicon){
            const iconUrl=new URL(favicon.dataset.mmIconSource||favicon.getAttribute('href'),location.href);
            iconUrl.searchParams.set('mm_variant',variant.id);
            if(favicon.getAttribute('href')!==iconUrl.href){
              const replacement=favicon.cloneNode(true);
              replacement.href=iconUrl.href;
              replacement.dataset.mmIconSource=iconUrl.href;
              favicon.replaceWith(replacement);
              const touchIcon=document.querySelector('link[rel="apple-touch-icon"]');
              if(touchIcon)touchIcon.href=iconUrl.href;
            }
          }
        }
        else{const details=product.parentElement.querySelector('.mm-quick-details');if(details)details.href=selectionUrl;}

      };
      form.querySelectorAll('[data-mm-product-step]').forEach(button=>button.addEventListener('click',()=>{if(button.disabled)return;if(Number(button.dataset.mmProductStep)<0)quantity.stepDown();else quantity.stepUp();quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
      form.addEventListener('change',sync);quantity.addEventListener('input',sync);sync();
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(!form.reportValidity()||add.disabled)return;if(cartBusy){status.textContent=messages.cart_updating;return;}
        const item={id:Number(variantSelect.value),quantity:Number(quantity.value)};
        let items=[item];
        if(!planSelect.disabled){
          item.selling_plan=Number(planSelect.value);
          const selectedPurchase=data.variants.find(variant=>variant.id===item.id);
          const target=selectedPurchase?.subscriptionTarget;
          if(Array.isArray(selectedPurchase?.subscriptionItems)){
            const components=selectedPurchase.subscriptionItems;
            if(!components.length||!components.every(component=>component.available&&!component.requiresComponents&&Number.isSafeInteger(component.variantId)&&component.variantId>0&&Number.isSafeInteger(component.sellingPlanId)&&component.sellingPlanId>0&&Number.isSafeInteger(component.quantityMultiplier)&&component.quantityMultiplier>0&&Number.isSafeInteger(item.quantity*component.quantityMultiplier))){status.textContent=messages.no_plan_variant;return;}
            items=components.map(component=>({id:component.variantId,quantity:item.quantity*component.quantityMultiplier,selling_plan:component.sellingPlanId}));
          }else if(target){
            if(!target.available||!Number.isSafeInteger(target.variantId)||target.variantId<1||!Number.isSafeInteger(target.quantityMultiplier)||target.quantityMultiplier<1||!Number.isSafeInteger(item.quantity*target.quantityMultiplier)){status.textContent=messages.no_plan_variant;return;}
            item.id=target.variantId;item.quantity*=target.quantityMultiplier;
          }
        }
        const directCheckout=Boolean(event.submitter?.matches('[data-mm-buy-now]'));
        cartBusy=true;sync();form.setAttribute('aria-busy','true');status.textContent=directCheckout?messages.checkout_pending:messages.adding;
        try{await post('cart/add.js',{items});if(directCheckout){location.assign(root+'checkout');return;}status.textContent=messages.added;const trigger=updateUrl?event.submitter:quickTrigger;if(!updateUrl)quickDialog.close();await openBag(trigger);toast(messages.added);}
        catch(error){status.textContent=error.message;status.setAttribute('role','alert');}
        finally{cartBusy=false;form.removeAttribute('aria-busy');sync();}
      });
    }
    document.querySelectorAll('[data-mm-product]').forEach(product=>initialiseProduct(product));
    const matchesFinderProduct=(rules,answers,item)=>{
      if(!item.available)return false;
      const category=rules.categories.find(option=>option.id===answers.category);
      const context=category?.choices.find(option=>option.id===answers.context);
      if(!context)return false;
      const includesEveryProduct=answers.category==='all'&&answers.context==='all';
      if(!includesEveryProduct&&!context.handles.includes(item.handle))return false;
      if(answers.purchase==='subscription'&&!item.subscription)return false;
      if(answers.purchase==='once'&&!item.once)return false;
      return true;
    };
    const finder=document.querySelector('[data-mm-finder]');
    if(finder) {
      const rules=JSON.parse(finder.querySelector('[data-mm-finder-rules]').textContent,(_key,value)=>typeof value==='string'?value.replace(/&amp;/g,'&').replace(/&#39;/g,"'").replace(/&quot;/g,'"').replace(/&lt;/g,'<').replace(/&gt;/g,'>'):value);
      const form=finder.querySelector('form');const result=finder.querySelector('[data-mm-finder-results]');
      const error=finder.querySelector('[data-mm-finder-error]');
      const query=new URLSearchParams(location.search);
      const entryCategory=rules.categories.find(category=>category.id===query.get('mm_format'))?.id||'';
      const entryPurchase=query.get('purchase')==='subscription'?'subscription':'all';
      let answers={category:entryCategory,context:'all',purchase:entryPurchase};
      let step=entryCategory?1:0;
      const fields=['category','context','purchase'];
      const category=()=>rules.categories.find(option=>option.id===answers.category);
      const syncRadios=()=>{
        form.querySelectorAll('input[type=radio]').forEach(input=>input.checked=answers[input.name]===input.value);
      };
      const renderContext=()=>{
        const current=category();const options=finder.querySelector('[data-mm-context-options]');options.replaceChildren();
        if(!current)return;
        finder.querySelector('[data-mm-context-title]').textContent=current.question;
        finder.querySelector('[data-mm-context-note]').textContent=current.note;
        current.choices.forEach(choice=>{
          const label=document.createElement('label');label.className='choice mm-choice mm-range-option';
          const input=document.createElement('input');input.type='radio';input.name='context';input.value=choice.id;input.checked=choice.id===answers.context;
          const text=document.createElement('span');const title=document.createElement('strong');title.textContent=choice.label;
          const description=document.createElement('span');description.className='small muted';description.textContent=choice.description;
          text.append(title,description);label.append(input,text);options.append(label);
        });
      };
      const renderStep=(focus=false)=>{
        finder.querySelectorAll('[data-mm-step]').forEach((element,index)=>element.hidden=index!==step);
        finder.querySelector('[data-mm-progress]').textContent=rules.messages.progress.replace('__STEP__',String(step+1));
        finder.querySelector('[data-mm-finder-progress]').style.width=((step+1)/3*100)+'%';
        finder.querySelector('[data-mm-back]').disabled=step===0;
        finder.querySelector('[data-mm-next]').textContent=step===2?rules.messages.show_results:rules.messages.next;
        error.textContent='';syncRadios();
        if(focus){const heading=finder.querySelector('[data-mm-step="'+step+'"] h2');heading.tabIndex=-1;heading.focus();}
      };
      const showResults=()=>{
        let count=0;
        finder.querySelectorAll('[data-mm-finder-handle]').forEach(element=>{
          const item={handle:element.dataset.mmFinderHandle,available:element.dataset.mmAvailable==='true',once:element.dataset.mmOnce==='true',subscription:element.dataset.mmSubscription==='true'};
          const visible=matchesFinderProduct(rules,answers,item);element.hidden=!visible;if(visible)count++;
          element.querySelectorAll('a[href]').forEach(link=>{const destination=new URL(link.href,location.href);if(!destination.pathname.includes('/products/'))return;if(answers.purchase==='subscription')destination.searchParams.set('purchase','subscription');else if(answers.purchase==='once')destination.searchParams.set('purchase','once');else destination.searchParams.delete('purchase');destination.searchParams.delete('selling_plan');link.href=destination;});
        });
        finder.querySelector('[data-mm-match-count]').textContent=rules.messages.count.replace('__COUNT__',String(count));
        const current=category();const choice=current.choices.find(option=>option.id===answers.context);const purchase=rules.purchases.find(option=>option.id===answers.purchase);
        finder.querySelector('[data-mm-answer-summary]').textContent=[current.label,choice.label,purchase.label].join(' · ');
        finder.querySelector('[data-mm-no-matches]').hidden=count>0;
        finder.querySelector('[data-mm-subscription-matches]').hidden=answers.purchase!=='subscription';
        form.hidden=true;result.hidden=false;finder.querySelector('[data-mm-results-heading]').focus();
      };
      form.addEventListener('change',event=>{
        const input=event.target;if(input.type!=='radio'||!fields.includes(input.name))return;
        if(input.name==='category'&&answers.category!==input.value){answers.context='all';answers.category=input.value;renderContext();}
        else answers[input.name]=input.value;
        error.textContent='';
      });
      form.addEventListener('submit',event=>{
        event.preventDefault();const field=fields[step];const value=new FormData(form).get(field);
        if(!value){error.textContent=rules.messages.choose;finder.querySelector('[data-mm-step="'+step+'"] input')?.focus();return;}
        answers[field]=String(value);
        if(step===0)renderContext();
        if(step<2){step++;renderStep(true);}else showResults();
      });
      finder.querySelector('[data-mm-back]').addEventListener('click',()=>{step=Math.max(0,step-1);renderStep(true);});
      finder.querySelectorAll('[data-mm-change-answers]').forEach(button=>button.addEventListener('click',()=>{result.hidden=true;form.hidden=false;step=0;renderStep(true);}));
      finder.querySelector('[data-mm-restart]').addEventListener('click',()=>{answers={category:'',context:'all',purchase:entryPurchase};step=0;form.reset();renderContext();result.hidden=true;form.hidden=false;renderStep(true);});
      renderContext();renderStep();form.hidden=false;
    }
    if(document.querySelector('[data-mm-full-cart]')){
      cartBusy=true;
      refresh().catch(error=>toast(error.message)).finally(()=>{cartBusy=false;});
    }
    const builder=document.querySelector('[data-mm-builder]');
    if(builder) {
      const products=JSON.parse(builder.querySelector('[data-mm-box-data]').textContent);
      const size=builder.querySelector('[data-mm-box-size]');const selected=[];
      const slots=builder.querySelector('[data-mm-box-slots]');const error=builder.querySelector('[data-mm-box-error]');const submit=builder.querySelector('[data-mm-box-submit]');
      const render=()=>{
        slots.replaceChildren();
        selected.forEach((id,index)=>{const product=products.find(p=>p.id===id);const row=document.createElement('div');row.className='box-slot';const text=document.createElement('p');text.className='small';text.textContent=product.title+' · '+product.variant+' · '+money(product.price);const remove=document.createElement('button');remove.className='iconbtn';remove.type='button';remove.textContent='×';remove.setAttribute('aria-label',messages.remove+' '+product.title);remove.addEventListener('click',()=>{selected.splice(index,1);render();});row.append(text,remove);slots.append(row);});
        builder.querySelector('[data-mm-box-count]').textContent=selected.length+' / '+size.value+' '+messages.items;
        builder.querySelector('[data-mm-box-total]').textContent=money(selected.reduce((sum,id)=>sum+products.find(p=>p.id===id).price,0));
        builder.querySelectorAll('[data-mm-box-add]').forEach(e=>e.disabled=selected.length>=Number(size.value)||!products.find(p=>String(p.id)===e.closest('[data-mm-builder-card]').querySelector('[data-mm-box-variant]').value)?.available);
      };
      builder.querySelectorAll('[data-mm-box-add]').forEach(e=>e.addEventListener('click',()=>{if(selected.length<Number(size.value)){selected.push(Number(e.closest('[data-mm-builder-card]').querySelector('[data-mm-box-variant]').value));error.textContent='';render();}}));
      builder.querySelectorAll('[data-mm-box-variant]').forEach(select=>select.addEventListener('change',render));
      size.addEventListener('change',()=>{if(selected.length>Number(size.value)){size.value=String(selected.length);error.textContent=messages.removeFirst;}render();});
      submit.addEventListener('click',async()=>{
        if(selected.length!==Number(size.value)){error.textContent=messages.completeBox;return;}
        if(cartBusy){error.textContent=messages.cart_updating;return;}
        cartBusy=true;submit.disabled=true;error.textContent='';const box='mm-'+Date.now();
        try{await post('cart/add.js',{items:selected.map(id=>({id,quantity:1,properties:{'_mm_box':box,'Box':messages.boxName}}))});selected.length=0;render();await openBag(submit);toast(messages.added);}
        catch(e){error.textContent=e.message;try{await refresh();}catch{}}
        finally{cartBusy=false;submit.disabled=false;}
      });render();
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();


  } catch(e) { console.error(e); }
})();
})();
